import { ComponentType, FC, HTMLProps, SVGAttributes } from 'react';

import DefectBeperktInzetbaarXs from '@/assets/icons/DefectBeperktInzetbaarXs';
import DefectInzetbaarXs from '@/assets/icons/DefectInzetbaarXs';
import DefectNietInzetbaarXs from '@/assets/icons/DefectNietInzetbaarXs';
import DefectZandloperXs from '@/assets/icons/DefectZandloperXs';
import UserXs from '@/assets/icons/UserXs';
import { defectSoortIcon, nietInzetbaarOfZandloper } from '@/components/defectRow/DefectRow';
import { Defect } from '@/types/Defecten';
import { dateWithDayOfWeekWithYearWithTime } from '@/utils/dateUtils';

import styles from './DefectRow.module.css';

const defectIconMap: Record<string, ComponentType<SVGAttributes<SVGSVGElement>>> = {
  DefectNietInzetbaarXs,
  DefectBeperktInzetbaarXs,
  DefectInzetbaarXs,
  DefectZandloperXs,
};

const TooltipDefectRow: FC<{ defect: Defect } & HTMLProps<HTMLDivElement>> = ({ defect }) => {
  const iconDefect = defectSoortIcon(defect.soort, null, new Date());
  const iconNietInzetbaar = nietInzetbaarOfZandloper(
    defect.nietMeerInzetbaarVanaf ? new Date(defect.nietMeerInzetbaarVanaf).getTime() : null,
    new Date(),
  );
  const IconDefect = defectIconMap[iconDefect];
  const IconNietInzetbaar = iconNietInzetbaar ? defectIconMap[iconNietInzetbaar] : null;
  return (
    <div className={[styles.defectRow, styles.defectRowInsideTooltip, styles.defectenRowIdentifiersStyle].join(' ')}>
      <div className={styles.iconDivStyle}>
        {IconDefect && (
          <IconDefect
            className={[styles.defectIconInsideTooltipStyle, styles[`tooltip-${defect.soort}`]].join(' ')}
            aria-hidden='true'
            width='18px'
            height='18px'
          />
        )}
        {defect.bron === 'HANDMATIG' && (
          <UserXs height='20px' width='20px' aria-label='User' className={styles.userIconInsideTooltipStyle} />
        )}
        {iconNietInzetbaar && iconNietInzetbaar != iconDefect && IconNietInzetbaar ? (
          <IconNietInzetbaar
            className={[styles.defectIconInsideTooltipStyle, styles[`tooltip-DEFECT_NIET_INZETBAAR`]].join(' ')}
            aria-hidden='true'
            width='18px'
            height='18px'
          />
        ) : (
          ''
        )}
      </div>
      <span
        className={styles.tooltipToelichting}
        style={defect.bron === 'HANDMATIG' ? { fontStyle: 'italic' } : undefined}
        title={defect.toelichting}
      >
        {defect.toelichting}
      </span>
      <div className={styles.timeDivStyle}>
        <span className={styles.tooltipTimeSpanStyle}>
          {dateWithDayOfWeekWithYearWithTime(
            iconNietInzetbaar && iconNietInzetbaar != iconDefect ? defect.nietMeerInzetbaarVanaf : defect.beginTijd,
          )}
        </span>
      </div>
    </div>
  );
};

export default TooltipDefectRow;
